var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIco16Show(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M7.333 0C3.283 0 0 4.01 0 4.745 0 5.48 3.283 9.49 7.333 9.49c4.05 0 7.334-4.01 7.334-4.745C14.667 4.011 11.383 0 7.333 0z",
    transform: "translate(-340 -175) translate(340 175) translate(.667 3.267)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.922 4.745c0 1.43-1.16 2.588-2.589 2.588S4.745 6.174 4.745 4.745s1.16-2.588 2.588-2.588c1.43 0 2.589 1.159 2.589 2.588z",
    transform: "translate(-340 -175) translate(340 175) translate(.667 3.267)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco16Show);
export default __webpack_public_path__ + "static/media/ico16Show.96912c4b.svg";
export { ForwardRef as ReactComponent };